<template>
  <div class="container">
    <h2>Panel de Administración</h2>
    <button @click="logout" class="btn btn-secondary btn-sm float-end mb-3">Cerrar sesión</button>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <h4>Usuarios</h4>
        <RegisterUser @userAdded="getUsers" />
        <ul class="list-group">
          <li v-for="u in users" :key="u.id" class="list-group-item">
            {{ u.name }} ({{ u.email }}) - {{ u.role }}
          </li>
        </ul>
      </div>
      <div class="col-md-4">
        <h4>Dispositivos</h4>
        <RegisterDevice @deviceAdded="getDevices" />
        <ul class="list-group">
          <li v-for="d in devices" :key="d.id" class="list-group-item">
            {{ d.name }} - {{ d.shelly_id }}
          </li>
        </ul>
      </div>
      <div class="col-md-4">
        <h4>Asignar dispositivo</h4>
        <AssignDevice :users="users" :devices="devices" @assigned="getUsers" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import RegisterUser from "../components/RegisterUser.vue";
import RegisterDevice from "../components/RegisterDevice.vue";
import AssignDevice from "../components/AssignDevice.vue";
export default {
  components: { RegisterUser, RegisterDevice, AssignDevice },
  data() {
    return { users: [], devices: [] };
  },
  async mounted() {
    this.getUsers();
    this.getDevices();
  },
  methods: {
    async getUsers() {
      const res = await api.listUsers();
      this.users = res.data;
    },
    async getDevices() {
      const res = await api.listDevices();
      this.devices = res.data;
    },
    logout() {
      localStorage.clear();
      this.$router.push("/login");
    },
  },
};
</script>
